import { render, staticRenderFns } from "./comp_RatioImage.vue?vue&type=template&id=522a6f96&scoped=true&"
import script from "./comp_RatioImage.vue?vue&type=script&lang=js&"
export * from "./comp_RatioImage.vue?vue&type=script&lang=js&"
import style0 from "./comp_RatioImage.vue?vue&type=style&index=0&id=522a6f96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522a6f96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VIcon,VProgressLinear})
